import { gql } from "@apollo/client";

export const passwordResetMail = gql`
  mutation passwordreset($email: String!) {
    passwordResetMail(email: $email) {
      success

      message

      error
    }
  }
`;
